<template>
  <div class="card card-performance-objective">
    <div class="card-header">
      <h3 class="mb-0">{{ objective.description }}</h3>
    </div>

    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col-12 col-lg-7">
            <p>Key Milestones</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Start Date</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>End Date</p>
          </div>
        </div><!-- /.row -->
      </li>

      <li v-for="milestone in milestones" :key="milestone.id">
        <div class="row">
          <div class="col-12 col-lg-7">
            <p class="sr-only">Key milestone</p>
            <div class="form-control-plaintext quill-html"><div v-html="milestone.description" /></div>
          </div>
          <div class="col-6 col-lg-2">
            <p class="sr-only">Key milestone start date</p>
            <p class="form-control-plaintext">{{ milestone.start_date | date('YYYY-MM-DD') }}</p>
          </div>
          <div class="col-6 col-lg-2">
            <p class="sr-only">Key milestone end date</p>
            <p class="form-control-plaintext">{{ milestone.end_date | date('YYYY-MM-DD') }}</p>
          </div>
        </div><!-- /.row -->
      </li>
    </ul> <!-- /.list-data -->

    <ul class="list-data no-hover">
      <li class="data-heading">
        <div class="row">
          <div class="col">
            <p>Objective Outcome.</p>
          </div>
        </div>
      </li>
      <li>
        <div class="p-3">
          <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              :name="`outcome-${objectiveIndex}`"
              v-validate="'required'"
              :data-vv-scope="`objectives.${objectiveIndex}`"
              :id="`checkMet-${objectiveIndex}`"
              v-model="stateOutcome"
              :value="true">
            <label class="form-check-label" :for="`checkMet-${objectiveIndex}`">Met</label>
          </div>

          <div class="form-check abc-checkbox abc-checkbox-success form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              :name="`outcome-${objectiveIndex}`"
              :id="`checkNotMet-${objectiveIndex}`"
              v-model="stateOutcome"
              :value="false">
            <label class="form-check-label" :for="`checkNotMet-${objectiveIndex}`">Not Met</label>
          </div>

          <help-block field="outcome"/>
        </div>
      </li>

      <li class="data-heading">
        <div class="row">
          <div class="col">
            <p>Achievements and capabilities demonstrated</p>
          </div>
        </div>
      </li>

      <li>
        <div class="row">
          <div class="col quill-wrapper">
            <quill-wrapper :config="quillConfig[0]" @change="setAchievements($event)" />
          </div>
        </div><!-- /.row -->
      </li>

      <li class="data-heading">
        <div class="row">
          <div class="col">
            <p>What worked well</p>
          </div>
        </div>
      </li>

      <li>
        <div class="row">
          <div class="col">
            <quill-wrapper :config="quillConfig[1]" @change="setWhatWorkedWell($event)" />
          </div>
        </div><!-- /.row -->
      </li>

      <li class="data-heading">
        <div class="row">
          <div class="col">
            <p>Challenges faced</p>
          </div>
        </div>
      </li>

      <li>
        <div class="row">
          <div class="col">
            <quill-wrapper :config="quillConfig[2]" @change="setChallenges($event)" />
          </div>
        </div><!-- /.row -->
      </li>
    </ul><!-- /.list-data -->
  </div><!-- /.card -->
</template>

<script>
import { placementPerformanceObjectiveMethods } from 'vx/helpers'

export default {
  inject: ['$validator'],

  props: {
    objective: {
      required: true,
      type: Object
    },
    objectiveIndex: {
      required: true,
      type: Number
    }
  },

  computed: {
    milestones () {
      return this.objective.milestones
    },

    stateOutcome: {
      get () {
        return this.objective.outcome
      },

      set (value) {
        this.setObjectiveProperty({
          objectiveIndex: this.objectiveIndex,
          property: 'outcome',
          value
        })
      }
    },

    stateAchievements: {
      get () {
        return this.objective.achievements
      },

      set (value) {
        this.setAchievements(value)
      }
    },

    stateWhatWorkedWell: {
      get () {
        return this.objective.what_worked_well
      },

      set (value) {
        this.setWhatWorkedWell(value)
      }
    },

    stateChallenges: {
      get () {
        return this.objective.challenges
      },

      set (value) {
        this.setChallenges(value)
      }
    },

    quillConfig () {
      return [
        {
          options: { placeholder: 'Add comments...' },
          value: this.stateAchievements
        },
        {
          options: { placeholder: 'Add comments...' },
          value: this.stateWhatWorkedWell
        },
        {
          options: { placeholder: 'Add comments...' },
          value: this.stateChallenges
        }
      ]
    }
  },

  methods: {
    ...placementPerformanceObjectiveMethods,

    setAchievements (value) {
      this.setObjectiveProperty({
        objectiveIndex: this.objectiveIndex,
        property: 'achievements',
        value
      })
    },

    setWhatWorkedWell (value) {
      this.setObjectiveProperty({
        objectiveIndex: this.objectiveIndex,
        property: 'what_worked_well',
        value
      })
    },

    setChallenges (value) {
      this.setObjectiveProperty({
        objectiveIndex: this.objectiveIndex,
        property: 'challenges',
        value
      })
    }
  }
}
</script>
